import { appUrl } from './appBase.js';

/** Posição do cartucho relativa ao console (CSS custom properties). */
export const CONSOLE_CART_LAYOUT = {
  segaMD: { insertY: '42%', cartWidth: '28%', slotGlow: '48% 38%' },
  segaMS: { insertY: '44%', cartWidth: '26%', slotGlow: '50% 40%' },
  snes: { insertY: '50%', cartWidth: '32%', slotGlow: '50% 52%' },
  nes: { insertY: '48%', cartWidth: '30%', slotGlow: '50% 50%' },
  atari2600: { insertY: '38%', cartWidth: '22%', slotGlow: '50% 36%' },
  n64: { insertY: '46%', cartWidth: '34%', slotGlow: '50% 48%' },
  gba: { insertY: '52%', cartWidth: '24%', slotGlow: '50% 54%' },
  gb: { insertY: '50%', cartWidth: '22%', slotGlow: '50% 52%' },
  nds: { insertY: '48%', cartWidth: '30%', slotGlow: '50% 50%' },
  psx: { insertY: '52%', cartWidth: '36%', slotGlow: '50% 54%' },
  '3ds': { insertY: '48%', cartWidth: '26%', slotGlow: '50% 50%' },
  wii: { insertY: '50%', cartWidth: '32%', slotGlow: '50% 52%' },
};

let manifestPromise = null;

export function loadConsoleManifest() {
  if (!manifestPromise) {
    manifestPromise = fetch(appUrl('img/consoles/consoles.json'), { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : {}))
      .catch(() => ({}));
  }
  return manifestPromise;
}

export function consoleImageUrl(ejsKey, manifest) {
  const rel = manifest?.[ejsKey]?.image;
  if (!rel) return null;
  return appUrl(rel);
}

export function cartImageForGame(game) {
  const src = game?.cartThumbnail || game?.thumbnail;
  if (!src) return null;
  return src.startsWith('http') ? src : appUrl(src);
}

export function layoutForConsole(ejsKey) {
  return CONSOLE_CART_LAYOUT[ejsKey] || { insertY: '48%', cartWidth: '28%', slotGlow: '50% 50%' };
}
